import React, { useEffect, useState } from 'react';
import { TextareaIterface } from './textareaTypes';
import styles from './textarea.module.scss';

const Textarea: React.FC<TextareaIterface> = ({
  errStatus,
  errMessage,
  placeholder,
  customWidth,
  onChange,
  name,
  customHeight,
  customMargin,
  inputValue,
}) => {
  const [value, setValue] = useState<string | number>('');
  const [err, setErr] = useState<boolean>(false);
  const [errText, setErrText] = useState<string>('Ошибка');

  useEffect(() => {
    if (errStatus) {
      setErr(true);
      setErrText(errMessage || 'Ошибка');
    } else {
      setErr(false);
    }
  }, [errStatus, errMessage]);

  useEffect(() => {
    setValue(inputValue || '');
  }, [inputValue]);

  const customStyle = {
    height: customHeight ? `${customHeight}px` : '64px',
    marginBottom: customMargin ? `${customMargin}px` : '8px',
    width: '100%',
  };

  const mainWidth = {
    margin: '0',
    maxWidth: customWidth ? `${customWidth}px` : '250px',
    height: customHeight ? `${customHeight}px` : '64px',
    width: '100%',
  };

  const style = err ? styles.inputError : styles.inputDefault;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    console.log('chnge');
    const newValue = event.target.value;
    setValue(newValue);

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div style={mainWidth}>
      <div className={style} style={customStyle}>
        <textarea
          placeholder={placeholder}
          onChange={handleChange}
          name={name ?? 'Text'}
          className={`${styles.inputStandart} spanGlobal`}
          value={value}
        />
      </div>
      {err && <span className={styles.span}>{errText}</span>}
    </div>
  );
};
export default Textarea;
